export default __webpack_public_path__ + "static/media/Electric-Boiler-Huayuan.74d22f75.jpg";